import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "alt", "size", "outlineWidth", "dimmed"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { pxToRem } from 'utils/ui';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Why this component doesn't use SVG filters:
 *
 * It would've been tempting to write this component in SVG,
 * using the same approach as `OutlinedImage`.
 *
 * This would've made it easier to share the implementation of
 * visual effects like the dimming/greying out between them.
 * .
 * However, masking out a rose shape from an image is generally
 * much simpler to implement using a CSS clip-path, whereas a
 * dynamic outline can only be implemented in SVG.
 *
 * SVGs are also rendered inline in the DOM, which means that
 * the (very long!) coordinates of the clip path would be repeated
 * for every single badge rendered on the page. The masking CSS class
 * on the other hand only needs to be inserted into the page once, and
 * can then be applied to any number of badges.
 *
 * (There are ways of re-using SVG filters across a document, but
 * it would require additional complexity to make this work in React
 * using context and portals.)
 *
 * So in order to keep these components easy to use, I opted for the
 * different implementations between the two at the expense of consistency.
 */

var ShadowWrapper = styled.div.withConfig({
  displayName: "RoseImage__ShadowWrapper",
  componentId: "sc-mrnbgf-0"
})(["display:inline-block;vertical-align:middle;filter:drop-shadow(0 1px 2px rgba(0,0,0,0.25));"]);
var MaskWrapper = styled.div.withConfig({
  displayName: "RoseImage__MaskWrapper",
  componentId: "sc-mrnbgf-1"
})(["background-color:white;clip-path:polygon( 44.7% 2.3%,45.9% 1.3%,48.6% 0.2%,51.4% 0.2%,54.1% 1.3%,55.3% 2.3%,55.3% 2.3%,57% 3.6%,61.2% 4.4%,63.4% 3.9%,63.4% 3.9%,64.8% 3.5%,67.7% 3.5%,70.4% 4.6%,72.4% 6.6%,73.1% 7.9%,73.1% 7.9%,74.3% 9.8%,77.8% 12.2%,80% 12.5%,80% 12.5%,81.5% 12.7%,84.2% 13.8%,86.2% 15.8%,87.3% 18.5%,87.5% 20%,87.5% 20%,87.8% 22.2%,90.2% 25.7%,92.1% 26.9%,92.1% 26.9%,93.4% 27.6%,95.4% 29.6%,96.5% 32.3%,96.5% 35.2%,96.1% 36.6%,96.1% 36.6%,95.6% 38.8%,96.4% 43%,97.7% 44.7%,97.7% 44.7%,98.7% 45.9%,99.8% 48.6%,99.8% 51.4%,98.7% 54.1%,97.7% 55.3%,97.7% 55.3%,96.4% 57%,95.6% 61.2%,96.1% 63.4%,96.1% 63.4%,96.5% 64.8%,96.5% 67.7%,95.4% 70.4%,93.4% 72.4%,92.1% 73.1%,92.1% 73.1%,90.2% 74.3%,87.8% 77.8%,87.5% 80%,87.5% 80%,87.3% 81.5%,86.2% 84.2%,84.2% 86.2%,81.5% 87.3%,80% 87.5%,80% 87.5%,77.8% 87.8%,74.3% 90.2%,73.1% 92.1%,73.1% 92.1%,72.4% 93.4%,70.4% 95.4%,67.7% 96.5%,64.8% 96.5%,63.4% 96.1%,63.4% 96.1%,61.2% 95.6%,57% 96.4%,55.3% 97.7%,55.3% 97.7%,54.1% 98.7%,51.4% 99.8%,48.6% 99.8%,45.9% 98.7%,44.7% 97.7%,44.7% 97.7%,43% 96.4%,38.8% 95.6%,36.6% 96.1%,36.6% 96.1%,35.2% 96.5%,32.3% 96.5%,29.6% 95.4%,27.6% 93.4%,26.9% 92.1%,26.9% 92.1%,25.7% 90.2%,22.2% 87.8%,20% 87.5%,20% 87.5%,18.5% 87.3%,15.8% 86.2%,13.8% 84.2%,12.7% 81.5%,12.5% 80%,12.5% 80%,12.2% 77.8%,9.8% 74.3%,7.9% 73.1%,7.9% 73.1%,6.6% 72.4%,4.6% 70.4%,3.5% 67.7%,3.5% 64.8%,3.9% 63.4%,3.9% 63.4%,4.4% 61.2%,3.6% 57%,2.3% 55.3%,2.3% 55.3%,1.3% 54.1%,0.2% 51.4%,0.2% 48.6%,1.3% 45.9%,2.3% 44.7%,2.3% 44.7%,3.6% 43%,4.4% 38.8%,3.9% 36.6%,3.9% 36.6%,3.5% 35.2%,3.5% 32.3%,4.6% 29.6%,6.6% 27.6%,7.9% 26.9%,7.9% 26.9%,9.8% 25.7%,12.2% 22.2%,12.5% 20%,12.5% 20%,12.7% 18.5%,13.8% 15.8%,15.8% 13.8%,18.5% 12.7%,20% 12.5%,20% 12.5%,22.2% 12.2%,25.7% 9.8%,26.9% 7.9%,26.9% 7.9%,27.6% 6.6%,29.6% 4.6%,32.3% 3.5%,35.2% 3.5%,36.6% 3.9%,36.6% 3.9%,38.8% 4.4%,43% 3.6%,44.7% 2.3%,44.7% 2.3%,44.7% 2.3% );"]);

// Mark some props as required in the Image component

var Image = styled.img.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['size', 'outlineWidth', 'dimmed'].includes(prop);
  },
  displayName: "RoseImage__Image",
  componentId: "sc-mrnbgf-2"
})(function (p) {
  var size = pxToRem(p.size);
  return css(["width:", ";height:", ";object-fit:cover;border-radius:50%;overflow:hidden;padding:", ";", ""], size, size, pxToRem(p.outlineWidth), p.dimmed && "\n\t\t\tfilter: grayscale(1);\n\t\t\topacity: 0.5;\n\t\t");
});
var RoseImage = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var src = _ref.src,
    alt = _ref.alt,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 60 : _ref$size,
    _ref$outlineWidth = _ref.outlineWidth,
    outlineWidth = _ref$outlineWidth === void 0 ? 0 : _ref$outlineWidth,
    _ref$dimmed = _ref.dimmed,
    dimmed = _ref$dimmed === void 0 ? false : _ref$dimmed,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ShadowWrapper, {
    ref: ref,
    children: /*#__PURE__*/_jsx(MaskWrapper, {
      children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, otherProps), {}, {
        src: src,
        size: size,
        alt: alt,
        dimmed: dimmed,
        outlineWidth: outlineWidth
      }))
    })
  });
});
RoseImage.displayName = 'RoseImage';
export default RoseImage;